<template lang="pug">
div(
  class="tl-content-collapse"
  :style="{ height: `${contentHeight}px` }"
)
    .content(ref="contentRef")
        slot

    template(
        v-if="expandAvailable"
    )
        div(
            v-if="!expanded"
            class="fade"
        )

        button(
            class="collapse-trigger"
            @click="toggleExpanded"
        )
            span {{ expanded ? labels.less: labels.more }}
            i(
                class="icon"
                :class="expanded ? 'mi-chevron-up' : 'mi-chevron-down'"
            )
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'

const resizeObserver = new ResizeObserver((entries) => {
    const heightOfChildren = entries[0].contentRect.height
    expandAvailable.value = heightOfChildren > props.height

    if (expandAvailable.value) {
        contentHeight.value = expanded.value
            ? Math.max(props.height, heightOfChildren)
            : Math.min(props.height, heightOfChildren)
        contentHeight.value += triggerMargin
    } else {
        contentHeight.value = heightOfChildren
        expanded.value = false
    }
})

const props = withDefaults(defineProps<{
    height: number
    labels?: {
        more: string
        less: string
    }
}>(), {
    labels: () => ({
        more: 'See more',
        less: 'See less',
    }),
})

const triggerMargin = 30
const expanded = ref(false)
const contentHeight = ref(props.height + triggerMargin)
const contentRef = ref<HTMLElement | null>(null)
const expandAvailable = ref(true)

onMounted(() => {
    resizeObserver.observe(contentRef.value as HTMLElement)
})

const toggleExpanded = () => {
    expanded.value = !expanded.value
    const height = expanded.value ? (contentRef.value?.offsetHeight || 0) : props.height
    contentHeight.value = height + triggerMargin
}
</script>

<style lang="sass" scoped>
.tl-content-collapse
    transition: all 0.2s ease-in-out
    position: relative
    overflow: hidden

    .collapse-trigger
        cursor: pointer
        position: absolute
        left: 50%
        bottom: 0
        transform: translate(-50%, 0)
        color: var(--tl-color-blue-600)
        background: transparent
        border: none

    .fade
        position: absolute
        bottom: 0
        left: 0
        right: 0
        height: 80px
        background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,0) 100%)
        pointer-events: none

    .icon
        margin-left: 4px
</style>
